var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBorderTop = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0418 16.6667C10.0418 16.6433 10.0235 16.625 10.0002 16.625C9.97683 16.625 9.9585 16.6433 9.9585 16.6667C9.9585 16.69 9.97683 16.7083 10.0002 16.7083C10.0235 16.7083 10.0418 16.69 10.0418 16.6667",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3753 16.6667C13.3753 16.6433 13.357 16.625 13.3337 16.625C13.3103 16.625 13.292 16.6433 13.292 16.6667C13.292 16.69 13.3103 16.7083 13.3337 16.7083C13.357 16.7083 13.3753 16.69 13.3753 16.6667",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70833 16.6667C6.70833 16.6433 6.69 16.625 6.66667 16.625C6.64333 16.625 6.625 16.6433 6.625 16.6667C6.625 16.69 6.64333 16.7083 6.66667 16.7083C6.69 16.7083 6.70833 16.69 6.70833 16.6667",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7083 9.99998C16.7083 9.97665 16.69 9.95831 16.6667 9.95831C16.6433 9.95831 16.625 9.97665 16.625 9.99998C16.625 10.0233 16.6433 10.0416 16.6667 10.0416C16.69 10.0416 16.7083 10.0233 16.7083 9.99998",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 13.375C16.69 13.375 16.7083 13.3567 16.7083 13.3334C16.7083 13.31 16.69 13.2917 16.6667 13.2917C16.6433 13.2917 16.625 13.31 16.625 13.3334C16.625 13.3567 16.6433 13.375 16.6667 13.375",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 6.70833C16.69 6.70833 16.7083 6.69 16.7083 6.66667C16.7083 6.64333 16.69 6.625 16.6667 6.625C16.6433 6.625 16.625 6.64333 16.625 6.66667C16.625 6.69 16.6433 6.70833 16.6667 6.70833",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7083 16.6667C16.7083 16.6433 16.69 16.625 16.6667 16.625C16.6433 16.625 16.625 16.6433 16.625 16.6667C16.625 16.69 16.6433 16.7083 16.6667 16.7083C16.69 16.7083 16.7083 16.69 16.7083 16.6667",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.37533 9.99998C3.37533 9.97665 3.35699 9.95831 3.33366 9.95831C3.31033 9.95831 3.29199 9.97665 3.29199 9.99998C3.29199 10.0233 3.31033 10.0416 3.33366 10.0416C3.35699 10.0416 3.37533 10.0233 3.37533 9.99998",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33366 13.375C3.35699 13.375 3.37533 13.3567 3.37533 13.3334C3.37533 13.31 3.35699 13.2917 3.33366 13.2917C3.31033 13.2917 3.29199 13.31 3.29199 13.3334C3.29199 13.3567 3.31033 13.375 3.33366 13.375",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33366 6.70833C3.35699 6.70833 3.37533 6.69 3.37533 6.66667C3.37533 6.64333 3.35699 6.625 3.33366 6.625C3.31033 6.625 3.29199 6.64333 3.29199 6.66667C3.29199 6.69 3.31033 6.70833 3.33366 6.70833",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.37533 16.6667C3.37533 16.6433 3.35699 16.625 3.33366 16.625C3.31033 16.625 3.29199 16.6433 3.29199 16.6667C3.29199 16.69 3.31033 16.7083 3.33366 16.7083C3.35699 16.7083 3.37533 16.69 3.37533 16.6667",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 3.33335H16.6668",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBorderTop);
export default ForwardRef;